import { observable, action, computed } from 'mobx';

export default class AppStore {
    rootStore;

    _initialized = observable.box(false);
    _initializePromise = null;

    constructor(rootStore) {

        this.rootStore = rootStore;
    }

    // @action kept for consistency with the store's action-based mutators, even though
    // this entry point only memoizes the promise; the observable write lives in setInitialized().
    @action
    initialize() {
        // Idempotent: repeat calls (e.g. a StrictMode double-mounted effect) reuse
        // the in-flight promise so authStore.initialize()/setupRouter() run exactly once.
        if (!this._initializePromise) {
            this._initializePromise = this._initialize();
        }
        return this._initializePromise;
    }

    async _initialize() {
        const { authStore } = this.rootStore;

        await authStore.initialize();
        // Uncomment this if you have languages and localization!
        //await localizationStore.initialize();
        this.rootStore.setupRouter();
        this.setInitialized();
    }

    @computed
    get initialized() {
        return this._initialized.get();
    }

    @action
    setInitialized() {
        this._initialized.set(true);
    }
}
